import { registerComponent } from '../../utils/vueUtils';
import TerkepInfoModal from './TerkepInfoModal.vue';
let modals = [TerkepInfoModal];
export const componentNames = [];
modals.forEach(component => {
  registerComponent(component);
  componentNames.push(component.name);
});
